// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCancelPolicy_root__3LkVB","container":"ModalCancelPolicy_container___PRMH","text":"ModalCancelPolicy_text__12Mbk"};